import React, { useEffect, useState } from 'react'
import Loading from '../../components/Loading'
import { Container } from './styles'
import Header from '../../components/header'
import Projects from '../../components/Projects'
import Skills from '../../components/Skills'
import About from '../../components/About'

export default function Home() {
  const [isLoading, setIsLoading] = useState(true)
  const [showElement, setShowElement] = useState('projects')

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false)
    }, 1000)
  }, [])

  const renderComponent = () => {
    switch (showElement) {
      case 'projects':
        return <Projects />
      case 'skills':
        return <Skills />
      case 'about':
        return <About />
      default:
        return null // Renderiza null se showElement não corresponder a nenhum valor
    }
  }

  return (
    <Container>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <Header />
          <nav className='links-internos' id='menu'>
            <a href='#menu' onClick={() => setShowElement('projects')}>
              Projetos
            </a>
            <a href='#menu' onClick={() => setShowElement('skills')}>
              Habilidades
            </a>
            <a href='#menu' onClick={() => setShowElement('about')}>
              Sobre mim
            </a>
          </nav>
          {renderComponent()}
        </>
      )}
    </Container>
  )
}
